import {
  makeStyles as makeStylesOriginal,
  createStyles as createStylesOriginal,
  withStyles as withStylesOriginal,
  Theme,
  Theme as DefaultTheme,
} from "@material-ui/core/styles";

import {
  Styles,
  WithStylesOptions,
  StyleRules,
} from "@material-ui/styles/withStyles";
import { StylesIndexInjections } from "common-react";

export * from "@material-ui/core/styles";

let InitialIndexForOtherWorkspacesThanUi = StylesIndexInjections.OTHER;

const sanitizeStyleOptions = <T extends DefaultTheme>(
  options?: Omit<WithStylesOptions<T>, "withTheme"> | WithStylesOptions<T>,
) => {
  if (!options?.name) {
    return options;
  }

  const name = options.name.trim();
  return name === options.name ? options : { ...options, name };
};

export const makeStyles = <T extends DefaultTheme, Props extends {} = {}, ClassKey extends string = string>(
  style: Styles<T, Props, ClassKey>,
  options?: Omit<WithStylesOptions<T>, "withTheme">,
) => makeStylesOriginal(style, {
  index: ++InitialIndexForOtherWorkspacesThanUi,
  ...sanitizeStyleOptions(options),
});

export const withStyles = <ClassKey extends string, Props extends {} = {}>(
  style: Styles<Theme, Props, ClassKey>,
  options?: WithStylesOptions<Theme>,
) => withStylesOriginal(style, {
  index: ++InitialIndexForOtherWorkspacesThanUi,
  ...sanitizeStyleOptions(options),
});

export const makeUiStyles = <T extends DefaultTheme, Props extends {} = {}, ClassKey extends string = string>(
  style: Styles<T, Props, ClassKey>,
  options: WithStylesOptions<T> & { index: StylesIndexInjections }
) => {
  const { index, ...rest } = sanitizeStyleOptions(options) ?? options;
  return makeStylesOriginal(style, { index, ...rest });
};

export const withUiStyles = <ClassKey extends string, Props extends {} = {}>(
  style: Styles<Theme, Props, ClassKey>,
  options: WithStylesOptions<Theme> & { index: StylesIndexInjections }
) => {
  const { index, ...rest } = sanitizeStyleOptions(options) ?? options;
  return withStylesOriginal(style, { index, ...rest });
};

export function createStyles<ClassKey extends string, Props extends {}>(
  styles: StyleRules<Props, ClassKey>,
): StyleRules<Props, ClassKey> {
  return createStylesOriginal(styles);
}
